import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { GrFormClose } from 'react-icons/gr';
import { currencyFormat } from '../../../helpers/global_helper';
import WLPagination from '../../WLPagination/WLPagination';

const ReferralPlayerList = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // default
    const [currentData, setCurrentData] = useState({});

    const data = props.data || []; // Your full dataset
    const totalPages = Math.ceil(data.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;

    useEffect(() => {
        const collectData = data.slice(startIndex, startIndex + itemsPerPage);
        let paginatedData = {};
        paginatedData['data'] = collectData
        paginatedData['page'] = 1
        paginatedData['per_page'] = itemsPerPage
        paginatedData['last_page'] = totalPages
        paginatedData['current_page'] = currentPage
        paginatedData['total'] = data.length
        setCurrentData(paginatedData);
    }, [data, currentPage, itemsPerPage]);

    const pageChange = (e) => {
        console.log("props pageChange ===>", e);
        setCurrentPage(e)
    }
    const perPageChange = (e) => {
        console.log("props perPageChange ===>", e);
        setItemsPerPage(e);
    }
    return (
        <div className="registration">
            <div className="container">
                <span className="close" onClick={() => props.handleRefPopup()} ><GrFormClose /></span>
                <div className="registerouter-main">
                    <h5 style={{color:"white", paddingLeft:"20px"}}>{props.t('username')} : {props.player}</h5>
                    <h6 style={{color:"white", paddingLeft:"20px"}}>{props.t('date')} : {props.date}</h6>
                    <div className='turn-popup-table-details'>
                        <div className='turn-popup-table p-2'>
                            <table style={{width:"100%", textAlign:"center"}}>
                                <thead style={{color:"#65337e"}}>
                                    <tr style={{display:"flex", justifyContent:"space-between"}}>
                                        <th width={100} className='text-center'>{(props.t('No.')).toUpperCase()}</th>
                                        <th width={100} className='text-center'>{props.t('username').toUpperCase()}</th>
                                        <th width={100} className='text-center'>{props.t('turnover').toUpperCase()}</th>
                                        <th width={100} className='text-center'>{props.t('bonus').toUpperCase()}</th>
                                    </tr>
                                </thead>
                                <tbody style={{color:"white"}}>
                                        {currentData?.data &&
                                            currentData?.data.map((d, i) => (
                                                <tr key={d._id?.$oid || i} style={{display:"flex", justifyContent:"space-between"}}>
                                                    <td width={100} className='text-center'>{startIndex + i + 1}</td>
                                                    <td width={100} className='text-center'>{d.username}</td>
                                                    <td width={100} className='text-center'>{currencyFormat(d.turnover_amount)}</td>
                                                    <td width={100} className='text-center'>{currencyFormat(d.amount)}</td>
                                                </tr>
                                            ))
                                        }
                                </tbody>
                                {currentData?.data && currentData?.data.length > 0 && (
                                    <WLPagination
                                        pageData={currentData}
                                        pageChange={pageChange}
                                        perPageChange={perPageChange}
                                    />
                                )}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

ReferralPlayerList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};
export default withTranslation()(ReferralPlayerList)
